
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import ImageLazyLoading from "widgets/image_lazyloading"
// Private Modules

// region Public Components

import ListingsCarousel from "concepts/listings/carousel"
import * as ListerSpeakingLanguagesBadge from "concepts/listings/feature/lister_speaking_languages/badge_with_popover"

import {
  init as listing_shortlist_button_init,
} from "concepts/listings/listing_shortlist_button/index"

// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--row--card"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)
  })

  ListerSpeakingLanguagesBadge.initAllMatchingElements()
  ListingsCarousel.init()
  ImageLazyLoading.default_lazyload_instance().update()
  listing_shortlist_button_init().done()
}

export default {
  init,
}
